import {
    IProps,
    IRef,
} from './types';

import React, {
    forwardRef,
    useImperativeHandle,
} from 'react';

import {
    useInputMask,
} from 'tools/hooks';

import StringInput from '../StringInput';

import {
    MASK,
} from './constants';
import {
    formatInitialValue,
    formatValue,
} from './functions';

const BigIntInput = forwardRef<IRef, IProps>((props, ref) => {
    const {value, setValue, inputProps} = useInputMask({
        value: formatInitialValue(props.value),
        mask: MASK,
        onChange(value: string) {
            props.onChangeValue?.(formatValue(value));
        },
    });

    useImperativeHandle(ref, () => {
        return {
            setValue(value: string | null) {
                setValue(formatInitialValue(value));
            },
        };
    });

    return (
        <StringInput
            className={props.className}
            value={value}
            size={props.size}
            label={props.label}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            isError={props.isError}
            errorMessage={props.errorMessage}
            {...inputProps}
        />
    );
});

export default BigIntInput;
